__turbopack_context__.v({
  "format": "index-module__YYtQXa__format",
  "mobilePhone": "index-module__YYtQXa__mobilePhone",
});
